<ng-container *ngIf="data && data.length > 0; else noClients">
	<div class="content-container clients_page d-block" *ngIf="activeTab === 'all-clients'">
		<h1>
			<span i18n="@@dashboard.clients">Clients</span>	
			<div class="d-flex">
				<div class="primary_btn" (click)="openAddClientModal()">
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
						<path d="M12 5V19M5 12H19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
					</svg>
					<span i18n="@@clients.add_new_client">Add new</span>
				</div>
				<div class="custom_select w-auto ms-2 me-2">
					<div class="custom_select-header"
						(click)="toggleDropdown($event)">
						<div i18n="@@clients.download_as">Download as</div>
						<div class="custom_select-icon">
							<svg xmlns="http://www.w3.org/2000/svg" width="24"
								height="24" viewBox="0 0 24 24" fill="none">
								<path d="M6 9L12 15L18 9" stroke="#0A0A0A"
									stroke-width="2" stroke-linecap="round"
									stroke-linejoin="round" />
							</svg>
						</div>
					</div>
					<ul class="custom_select-content p-0" style="display: none;">
						<li class="custom_select-item" href="/clients/download_pdf" (click)="downloadPDF()">
							<span>
								<svg class="me-1" xmlns="http://www.w3.org/2000/svg" width="16"
									height="17" viewBox="0 0 16 17" fill="none">
									<path d="M6 7.8335V11.8335L7.33333 10.5002"
										stroke="#646464" stroke-width="1.5"
										stroke-linecap="round"
										stroke-linejoin="round" />
									<path d="M5.99996 11.8333L4.66663 10.5"
										stroke="#646464" stroke-width="1.5"
										stroke-linecap="round"
										stroke-linejoin="round" />
									<path
										d="M14.6667 7.16683V10.5002C14.6667 13.8335 13.3334 15.1668 10 15.1668H6.00004C2.66671 15.1668 1.33337 13.8335 1.33337 10.5002V6.50016C1.33337 3.16683 2.66671 1.8335 6.00004 1.8335H9.33337"
										stroke="#646464" stroke-width="1.5"
										stroke-linecap="round"
										stroke-linejoin="round" />
									<path
										d="M14.6667 7.16683H12C10 7.16683 9.33337 6.50016 9.33337 4.50016V1.8335L14.6667 7.16683Z"
										stroke="#646464" stroke-width="1.5"
										stroke-linecap="round"
										stroke-linejoin="round" />
								</svg>
								<span i18n="@@dashboard.pdf">PDF</span>
							</span>
						</li>
						<li class="custom_select-item"  href="/clients/download" (click)="exportClient()">
							<span>
								<svg  class="me-1" xmlns="http://www.w3.org/2000/svg" width="16"
									height="17" viewBox="0 0 16 17" fill="none">
									<path d="M6 7.8335V11.8335L7.33333 10.5002"
										stroke="#646464" stroke-width="1.5"
										stroke-linecap="round"
										stroke-linejoin="round" />
									<path d="M5.99996 11.8333L4.66663 10.5"
										stroke="#646464" stroke-width="1.5"
										stroke-linecap="round"
										stroke-linejoin="round" />
									<path
										d="M14.6667 7.16683V10.5002C14.6667 13.8335 13.3334 15.1668 10 15.1668H6.00004C2.66671 15.1668 1.33337 13.8335 1.33337 10.5002V6.50016C1.33337 3.16683 2.66671 1.8335 6.00004 1.8335H9.33337"
										stroke="#646464" stroke-width="1.5"
										stroke-linecap="round"
										stroke-linejoin="round" />
									<path
										d="M14.6667 7.16683H12C10 7.16683 9.33337 6.50016 9.33337 4.50016V1.8335L14.6667 7.16683Z"
										stroke="#646464" stroke-width="1.5"
										stroke-linecap="round"
										stroke-linejoin="round" />
								</svg>
								<span i18n="@@dashboard.xlsx">XLSX</span>
							</span>
						</li>
					</ul>
				</div>

				<!-- <a href="/clients/download" class="downloadXl" (click)="exportClient()">
					<svg xmlns="http://www.w3.org/2000/svg" width="26" height="25" viewBox="0 0 26 25">
						<g fill="#0CC5D1" fill-rule="evenodd">
							<path d="M24.375 19.458h-9.75v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438V8.108h2.438a.812.812 0 1 0 0-1.622h-2.438V4.864h9.75v14.594zM13 22.534L1.625 20.407V3.916L13 1.789v20.745zM25.188 3.243H14.624V.811a.808.808 0 0 0-.962-.796l-13 2.432A.809.809 0 0 0 0 3.243V21.08c0 .389.278.724.663.796l13 2.432a.813.813 0 0 0 .962-.796V21.08h10.563a.812.812 0 0 0 .812-.811V4.054a.812.812 0 0 0-.813-.811z" />
							<path d="M20.129 8.387h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M20.129 11.892h1.677a.839.839 0 0 0 0-1.678H20.13a.839.839 0 0 0 0 1.678M20.129 14.677h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M20.129 17.463h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M7.953 12.351l2.681-3.447a.838.838 0 1 0-1.323-1.032l-2.483 3.193-2.092-2.391a.838.838 0 1 0-1.263 1.104l2.306 2.636-2.338 3.007a.84.84 0 0 0 .663 1.353c.248 0 .496-.11.66-.322l2.14-2.752 2.439 2.787a.836.836 0 0 0 1.184.08.837.837 0 0 0 .079-1.183L7.953 12.35z" />
						</g>
					</svg>
					<span i18n="@@common.download_xls">download .xls</span>
				</a> -->
			</div>
		</h1>

		<div class="table_block">
			<div class="filters_block">
				<svg class="search_icon start-100 end-2" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
					viewBox="0 0 24 24" fill="none">
					<path
						d="M21 21L17.5001 17.5M20 11.5C20 16.1944 16.1944 20 11.5 20C6.80558 20 3 16.1944 3 11.5C3 6.80558 6.80558 3 11.5 3C16.1944 3 20 6.80558 20 11.5Z"
						stroke="#757575" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
				</svg>
				<input type="text" class="filters_search pl-2 pr-5" (keyup)="searchClients($event.target.value)" placeholder="Search clients" name="data-table__search--input" i18n-placeholder="@@input.search_here" #searchInput>
				<div class="filters_btn_wrap">
					<div class="d-flex align-center">
						<svg [ngClass]="{ 'active': viewMode === 'card' }" (click)="switchView('card')" class="changeToList"
							width="48" height="40" viewBox="0 0 48 40" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M0.5 8C0.5 3.85786 3.85786 0.5 8 0.5H47.5V39.5H8C3.85787 39.5 0.5 36.1421 0.5 32V8Z"
								fill="white" />
							<path d="M0.5 8C0.5 3.85786 3.85786 0.5 8 0.5H47.5V39.5H8C3.85787 39.5 0.5 36.1421 0.5 32V8Z"
								stroke="#E0E0E0" />
							<path
								d="M24 14C24.5523 14 25 13.5523 25 13C25 12.4477 24.5523 12 24 12C23.4477 12 23 12.4477 23 13C23 13.5523 23.4477 14 24 14Z"
								stroke="#323232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
							<path
								d="M24 21C24.5523 21 25 20.5523 25 20C25 19.4477 24.5523 19 24 19C23.4477 19 23 19.4477 23 20C23 20.5523 23.4477 21 24 21Z"
								stroke="#323232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
							<path
								d="M24 28C24.5523 28 25 27.5523 25 27C25 26.4477 24.5523 26 24 26C23.4477 26 23 26.4477 23 27C23 27.5523 23.4477 28 24 28Z"
								stroke="#323232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
							<path
								d="M31 14C31.5523 14 32 13.5523 32 13C32 12.4477 31.5523 12 31 12C30.4477 12 30 12.4477 30 13C30 13.5523 30.4477 14 31 14Z"
								stroke="#323232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
							<path
								d="M31 21C31.5523 21 32 20.5523 32 20C32 19.4477 31.5523 19 31 19C30.4477 19 30 19.4477 30 20C30 20.5523 30.4477 21 31 21Z"
								stroke="#323232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
							<path
								d="M31 28C31.5523 28 32 27.5523 32 27C32 26.4477 31.5523 26 31 26C30.4477 26 30 26.4477 30 27C30 27.5523 30.4477 28 31 28Z"
								stroke="#323232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
							<path
								d="M17 14C17.5523 14 18 13.5523 18 13C18 12.4477 17.5523 12 17 12C16.4477 12 16 12.4477 16 13C16 13.5523 16.4477 14 17 14Z"
								stroke="#323232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
							<path
								d="M17 21C17.5523 21 18 20.5523 18 20C18 19.4477 17.5523 19 17 19C16.4477 19 16 19.4477 16 20C16 20.5523 16.4477 21 17 21Z"
								stroke="#323232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
							<path
								d="M17 28C17.5523 28 18 27.5523 18 27C18 26.4477 17.5523 26 17 26C16.4477 26 16 26.4477 16 27C16 27.5523 16.4477 28 17 28Z"
								stroke="#323232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
						</svg>

						<svg [ngClass]="{ 'active': viewMode === 'list' }" (click)="switchView('list')"
							class="changeToTable" width="48" height="40" viewBox="0 0 48 40" fill="none"
							xmlns="http://www.w3.org/2000/svg">
							<mask id="path-1-inside-1_62_44956" fill="white">
								<path d="M0 0H40C44.4183 0 48 3.58172 48 8V32C48 36.4183 44.4183 40 40 40H0V0Z" />
							</mask>
							<path d="M0 0H40C44.4183 0 48 3.58172 48 8V32C48 36.4183 44.4183 40 40 40H0V0Z"
								fill="#FAFAFA" />
							<path
								d="M0 -1H40C44.9706 -1 49 3.02944 49 8H47C47 4.13401 43.866 1 40 1H0V-1ZM49 32C49 36.9706 44.9706 41 40 41H0V39H40C43.866 39 47 35.866 47 32H49ZM0 40V0V40ZM40 -1C44.9706 -1 49 3.02944 49 8V32C49 36.9706 44.9706 41 40 41V39C43.866 39 47 35.866 47 32V8C47 4.13401 43.866 1 40 1V-1Z"
								fill="#E0E0E0" mask="url(#path-1-inside-1_62_44956)" />
							<path
								d="M33 20L21 20M33 14L21 14M33 26L21 26M17 20C17 20.5523 16.5523 21 16 21C15.4477 21 15 20.5523 15 20C15 19.4477 15.4477 19 16 19C16.5523 19 17 19.4477 17 20ZM17 14C17 14.5523 16.5523 15 16 15C15.4477 15 15 14.5523 15 14C15 13.4477 15.4477 13 16 13C16.5523 13 17 13.4477 17 14ZM17 26C17 26.5523 16.5523 27 16 27C15.4477 27 15 26.5523 15 26C15 25.4477 15.4477 25 16 25C16.5523 25 17 25.4477 17 26Z"
								stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
						</svg>
					</div>
				</div>
			</div>
			<table class="marketing_table clients_item" [ngClass]="{ 'card-view': viewMode === 'card', 'list-view': viewMode === 'list' }">
				<thead>
					<tr>
						<!-- <th>
							<div class="custom-checkbox">
								<input class="orders_inputAll" type="checkbox" id="select-all">
								<svg class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
									viewBox="0 0 24 24" fill="none">
									<rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2" />
								</svg>
								<svg class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6"
										stroke-width="2" />
									<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2"
										stroke-linecap="round" stroke-linejoin="round" />
								</svg>
							</div>
						</th> -->
						<th i18n="@@clients.name">Name</th>
						<th i18n="@@clients.client_id">Client ID</th>
						<th i18n="@@clients.client_phone">Phone</th>
						<th i18n="@@clients.email">Email</th>
						<th i18n="@@clients.address">Address</th>
						<th i18n="@@clients.date_of_birth">Birth date</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<ng-container *ngIf="data && data.length > 0">
						<tr *ngFor="let row of data | paginate: paginator; index as i">
							<!-- <td>
								<div class="custom-checkbox">
									<input class="select-item" type="checkbox" id="{{name}}-styled-checkbox-{{i}}"
										type="checkbox" (click)="toggleSelect(row[selectKey], row)"
										[checked]="selected.includes(row[selectKey])">
									<svg class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
										viewBox="0 0 24 24" fill="none">
										<rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2" />
									</svg>
									<svg class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6"
											stroke-width="2" />
										<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2"
											stroke-linecap="round" stroke-linejoin="round" />
									</svg>
								</div>
							</td> -->
							<td data-label="Name">
								<span>{{ row.full_name }}</span>
								<div class="position-absolute d-none-block d-none" style="top: 3px;right: 10px;">
									<div class="options-menu" [style.display]="isMenuVisible(row.id) ? 'block' : 'none'">
										<button class="edit-option" (click)="editClient(row, 'view')">
											<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
												<g clip-path="url(#clip0_197_12132)"> <path d="M14.6668 1.33203L7.3335 8.66536" stroke="#565656" stroke-linecap="round" stroke-linejoin="round" />
													<path d="M14.6668 1.33203L10.0002 14.6654L7.3335 8.66536L1.3335 5.9987L14.6668 1.33203Z" stroke="#565656" stroke-linecap="round" stroke-linejoin="round" />
												</g>
												<defs>
													<clipPath id="clip0_197_12132">
														<rect width="16" height="16" fill="white" />
													</clipPath>
												</defs>
											</svg>
											<span i18n="@@clients.view_statement" style="white-space: nowrap;">
												View statement
											</span>
										</button>
										<button class="edit-option" (click)="editClient(row, 'edit')">
											<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
												viewBox="0 0 20 20" fill="none">
												<path
													d="M14.9999 8.33332L11.6666 4.99999M2.08325 17.9167L4.90356 17.6033C5.24813 17.565 5.42042 17.5459 5.58146 17.4937C5.72433 17.4475 5.86029 17.3821 5.98566 17.2995C6.12696 17.2063 6.24954 17.0837 6.49469 16.8386L17.4999 5.83332C18.4204 4.91285 18.4204 3.42046 17.4999 2.49999C16.5795 1.57951 15.0871 1.57951 14.1666 2.49999L3.16136 13.5052C2.91621 13.7504 2.79363 13.8729 2.70045 14.0142C2.61778 14.1396 2.55243 14.2756 2.50618 14.4185C2.45405 14.5795 2.43491 14.7518 2.39662 15.0964L2.08325 17.9167Z"
													stroke="#393939" stroke-width="1.5" stroke-linecap="round"
													stroke-linejoin="round" />
											</svg>
											<span i18n="@@clients.edit">
												Edit
											</span>
										</button>
										<button class="delete-option" (click)="deleteClient(row)">
											<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
												viewBox="0 0 20 20" fill="none">
												<path
													d="M13.3333 5.00002V4.33335C13.3333 3.39993 13.3333 2.93322 13.1517 2.5767C12.9919 2.2631 12.7369 2.00813 12.4233 1.84834C12.0668 1.66669 11.6001 1.66669 10.6667 1.66669H9.33333C8.39991 1.66669 7.9332 1.66669 7.57668 1.84834C7.26308 2.00813 7.00811 2.2631 6.84832 2.5767C6.66667 2.93322 6.66667 3.39993 6.66667 4.33335V5.00002M2.5 5.00002H17.5M15.8333 5.00002V14.3334C15.8333 15.7335 15.8333 16.4336 15.5608 16.9683C15.3212 17.4387 14.9387 17.8212 14.4683 18.0609C13.9335 18.3334 13.2335 18.3334 11.8333 18.3334H8.16667C6.76654 18.3334 6.06647 18.3334 5.53169 18.0609C5.06129 17.8212 4.67883 17.4387 4.43915 16.9683C4.16667 16.4336 4.16667 15.7335 4.16667 14.3334V5.00002"
													stroke="#EB1461" stroke-width="1.5" stroke-linecap="round"
													stroke-linejoin="round" />
											</svg>
											<span i18n="@@clients.delete">
												Delete
											</span>
										</button>
									</div>
									<div class="dots_container-rounded w-100" (click)="toggleOptions(row.id)">
										<svg class="dots-menu" xmlns="http://www.w3.org/2000/svg" width="19" height="18"
											viewBox="0 0 19 18" fill="none">
											<path
												d="M9.5 9.75C9.91421 9.75 10.25 9.41421 10.25 9C10.25 8.58579 9.91421 8.25 9.5 8.25C9.08579 8.25 8.75 8.58579 8.75 9C8.75 9.41421 9.08579 9.75 9.5 9.75Z"
												stroke="#393939" stroke-width="2" stroke-linecap="round"
												stroke-linejoin="round" />
											<path
												d="M9.5 4.5C9.91421 4.5 10.25 4.16421 10.25 3.75C10.25 3.33579 9.91421 3 9.5 3C9.08579 3 8.75 3.33579 8.75 3.75C8.75 4.16421 9.08579 4.5 9.5 4.5Z"
												stroke="#393939" stroke-width="2" stroke-linecap="round"
												stroke-linejoin="round" />
											<path
												d="M9.5 15C9.91421 15 10.25 14.6642 10.25 14.25C10.25 13.8358 9.91421 13.5 9.5 13.5C9.08579 13.5 8.75 13.8358 8.75 14.25C8.75 14.6642 9.08579 15 9.5 15Z"
												stroke="#393939" stroke-width="2" stroke-linecap="round"
												stroke-linejoin="round" />
										</svg>
									</div>
								</div>
							</td>
							<td data-label="Client ID">
								<span>#{{ row.id }}</span>
							</td>
							<td data-label="Phone">
								<span>{{ row.phone }}</span>
							</td>
							<td data-label="Email">
								<span>{{ row.email }}</span>
							</td>
							<td data-label="Address">
								<span>{{ row.address }}</span>
							</td>
							<td data-label="Birth date" class="border-bottom-none-0">
								<span>{{ row.date_of_birth | date:'dd/MM/yyyy' }}</span>
							</td>
							<td data-label="" class="d-none-none">
								<div class="position-relative">
									<div class="options-menu" [style.display]="isMenuVisible(row.id) ? 'block' : 'none'">
										<button class="edit-option" (click)="editClient(row, 'view')">
											<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
												<g clip-path="url(#clip0_197_12132)"> <path d="M14.6668 1.33203L7.3335 8.66536" stroke="#565656" stroke-linecap="round" stroke-linejoin="round" />
													<path d="M14.6668 1.33203L10.0002 14.6654L7.3335 8.66536L1.3335 5.9987L14.6668 1.33203Z" stroke="#565656" stroke-linecap="round" stroke-linejoin="round" />
												</g>
												<defs>
													<clipPath id="clip0_197_12132">
														<rect width="16" height="16" fill="white" />
													</clipPath>
												</defs>
											</svg>
											<span i18n="@@clients.view_statement">
												View statement
											</span>
										</button>
										<button class="edit-option" (click)="editClient(row)">
											<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
												viewBox="0 0 20 20" fill="none">
												<path
													d="M14.9999 8.33332L11.6666 4.99999M2.08325 17.9167L4.90356 17.6033C5.24813 17.565 5.42042 17.5459 5.58146 17.4937C5.72433 17.4475 5.86029 17.3821 5.98566 17.2995C6.12696 17.2063 6.24954 17.0837 6.49469 16.8386L17.4999 5.83332C18.4204 4.91285 18.4204 3.42046 17.4999 2.49999C16.5795 1.57951 15.0871 1.57951 14.1666 2.49999L3.16136 13.5052C2.91621 13.7504 2.79363 13.8729 2.70045 14.0142C2.61778 14.1396 2.55243 14.2756 2.50618 14.4185C2.45405 14.5795 2.43491 14.7518 2.39662 15.0964L2.08325 17.9167Z"
													stroke="#393939" stroke-width="1.5" stroke-linecap="round"
													stroke-linejoin="round" />
											</svg>
											<span i18n="@@clients.edit">
												Edit
											</span>
										</button>
										<button class="delete-option" (click)="deleteClient(row)">
											<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
												viewBox="0 0 20 20" fill="none">
												<path
													d="M13.3333 5.00002V4.33335C13.3333 3.39993 13.3333 2.93322 13.1517 2.5767C12.9919 2.2631 12.7369 2.00813 12.4233 1.84834C12.0668 1.66669 11.6001 1.66669 10.6667 1.66669H9.33333C8.39991 1.66669 7.9332 1.66669 7.57668 1.84834C7.26308 2.00813 7.00811 2.2631 6.84832 2.5767C6.66667 2.93322 6.66667 3.39993 6.66667 4.33335V5.00002M2.5 5.00002H17.5M15.8333 5.00002V14.3334C15.8333 15.7335 15.8333 16.4336 15.5608 16.9683C15.3212 17.4387 14.9387 17.8212 14.4683 18.0609C13.9335 18.3334 13.2335 18.3334 11.8333 18.3334H8.16667C6.76654 18.3334 6.06647 18.3334 5.53169 18.0609C5.06129 17.8212 4.67883 17.4387 4.43915 16.9683C4.16667 16.4336 4.16667 15.7335 4.16667 14.3334V5.00002"
													stroke="#EB1461" stroke-width="1.5" stroke-linecap="round"
													stroke-linejoin="round" />
											</svg>
											<span i18n="@@clients.delete">
												Delete
											</span>
										</button>
									</div>
									<div class="dots_container-rounded w-100" (click)="toggleOptions(row.id)">
										<svg class="dots-menu" xmlns="http://www.w3.org/2000/svg" width="19" height="18"
											viewBox="0 0 19 18" fill="none">
											<path
												d="M9.5 9.75C9.91421 9.75 10.25 9.41421 10.25 9C10.25 8.58579 9.91421 8.25 9.5 8.25C9.08579 8.25 8.75 8.58579 8.75 9C8.75 9.41421 9.08579 9.75 9.5 9.75Z"
												stroke="#393939" stroke-width="2" stroke-linecap="round"
												stroke-linejoin="round" />
											<path
												d="M9.5 4.5C9.91421 4.5 10.25 4.16421 10.25 3.75C10.25 3.33579 9.91421 3 9.5 3C9.08579 3 8.75 3.33579 8.75 3.75C8.75 4.16421 9.08579 4.5 9.5 4.5Z"
												stroke="#393939" stroke-width="2" stroke-linecap="round"
												stroke-linejoin="round" />
											<path
												d="M9.5 15C9.91421 15 10.25 14.6642 10.25 14.25C10.25 13.8358 9.91421 13.5 9.5 13.5C9.08579 13.5 8.75 13.8358 8.75 14.25C8.75 14.6642 9.08579 15 9.5 15Z"
												stroke="#393939" stroke-width="2" stroke-linecap="round"
												stroke-linejoin="round" />
										</svg>
									</div>
								</div>
							</td>
						</tr>
					</ng-container>
				</tbody>
			</table>
			<ng-container>
				<div class="pagination_wrapper">
					<div class="showing_results">
						<div class="select_wrapper">
							<ng-container i18n="@@show">Show</ng-container>
							<select class="select-link tab-links-select" id="tab-links-select" nice-select
								[(ngModel)]="paginator.itemsPerPage" (change)="onChangeItemsPerPage($event, p)">
								<option *ngFor="let option of itemsPerPageOptions" [value]="option">{{ option }}</option>
							</select>
							<ng-container i18n="@@items">items</ng-container>
						</div>
						<div class="results_list" *ngIf="paginator?.from || paginator?.to">
							<ng-container i18n="@@showing_from">Showing from</ng-container> {{ paginator?.from }}
							<ng-container i18n="@@to">to</ng-container> {{ paginator?.to }} <ng-container
								i18n="@@of">of</ng-container> {{ paginator?.totalItems }} <ng-container
								i18n="@@items">items</ng-container>
						</div>
					</div>
					<nav pagination-template #p="paginationApi" [id]="paginator.id" (pageChange)="getPage($event)"
						aria-label="...">
						<ul class="pagination justify-content-center">
							<li class="page-item" [class.disabled]="p.isFirstPage()">
								<a *ngIf="!p.isFirstPage()" class="page-link prev" tabindex="-1" (click)="p.previous()">
									<svg width="7.5" height="13.5">
										<path d="M6.75 12.75l-6-6 6-6" fill="none" class="color-stroke"
											stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
									</svg>
								</a>
							</li>

							<li *ngFor="let page of p.pages" class="page-item"
								[class.active]="p.getCurrent() === page.value">
								<a *ngIf="p.getCurrent() !== page.value" (click)="p.setCurrent(page.value)"
									class="page-link">
									<span>{{ page.label }}</span>
								</a>
								<a *ngIf="p.getCurrent() === page.value" class="page-link">{{page.label}}
									<span class="sr-only">(current)</span></a>
							</li>

							<li class="page-item" [class.disabled]="p.isLastPage()">
								<a *ngIf="!p.isLastPage()" (click)="p.next()" class="page-link next">
									<svg width="7.5" height="13.5">
										<path d="M.75.75l6 6-6 6" fill="none" class="color-stroke" stroke-linecap="round"
											stroke-linejoin="round" stroke-width="1.5" />
									</svg>
								</a>
							</li>
						</ul>
					</nav>
				</div>
			</ng-container>
		</div>

		<!-- <ng-template #noClients>
			<div class="empty_clients_page" *ngIf="!loading">
				<img src="./images/NoResults.svg" alt="">
				<span i18n="@@clients.no_clients_message">You haven’t added any clients yet</span>
				<div class="primary_btn" (click)="openAddClientModal()">
					<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
						<path d="M12.5 5V19M5.5 12H19.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>  
					<span i18n="@@clients.first_client">
						Add my first client
					</span>
				</div>
			</div>
		</ng-template> -->
	</div>

	<div class="content-container clientss">
		<section class="data-table">
			<!-- <clients-header [totalclients]="clientsCount"></clients-header> -->

			<div class="data-table__wrap">
				<!-- <header class="data-table__create-section" *ngIf="activeTab === 'all-clients'">
					<div class="search-field">
						<div class="search-icon">
							<svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19">
								<g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-width="1.5"
									transform="translate(1 1)">
									<circle cx="7" cy="7" r="7" />
									<path stroke-linecap="square" d="M13.5 12.5L18 17" />
								</g>
							</svg>
						</div>
						<input type="text" (keyup)="searchClients($event.target.value)" name="data-table__search--input"
							i18n-placeholder="@@input.search_here" placeholder="Search invoices" #searchInput>
					</div>
					<div class="create-download">
						<a (click)="openAddClientModal()" class="tu-btn pink add-button text-white">
							<svg width="14" height="14" viewBox="0 0 14 14">
								<g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-linecap="square" stroke-width="2">
									<path d="M1 7h12M7 1v12" />
								</g>
							</svg>
							<span i18n="@@clients.add_new_client">Add new client</span>

						</a>
						<a href="/clients/download" class="downloadXl" (click)="exportClient()">
							<svg xmlns="http://www.w3.org/2000/svg" width="26" height="25" viewBox="0 0 26 25">
								<g fill="#0CC5D1" fill-rule="evenodd">
									<path
										d="M24.375 19.458h-9.75v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438V8.108h2.438a.812.812 0 1 0 0-1.622h-2.438V4.864h9.75v14.594zM13 22.534L1.625 20.407V3.916L13 1.789v20.745zM25.188 3.243H14.624V.811a.808.808 0 0 0-.962-.796l-13 2.432A.809.809 0 0 0 0 3.243V21.08c0 .389.278.724.663.796l13 2.432a.813.813 0 0 0 .962-.796V21.08h10.563a.812.812 0 0 0 .812-.811V4.054a.812.812 0 0 0-.813-.811z" />
									<path
										d="M20.129 8.387h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M20.129 11.892h1.677a.839.839 0 0 0 0-1.678H20.13a.839.839 0 0 0 0 1.678M20.129 14.677h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M20.129 17.463h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M7.953 12.351l2.681-3.447a.838.838 0 1 0-1.323-1.032l-2.483 3.193-2.092-2.391a.838.838 0 1 0-1.263 1.104l2.306 2.636-2.338 3.007a.84.84 0 0 0 .663 1.353c.248 0 .496-.11.66-.322l2.14-2.752 2.439 2.787a.836.836 0 0 0 1.184.08.837.837 0 0 0 .079-1.183L7.953 12.35z" />
								</g>
							</svg>
							<span i18n="@@common.download_xls">download .xls</span>
						</a>

					</div>
				</header> -->
				<!-- end header -->
				<!-- <div class="data-table__filter">
					<div class="top-filter">
						<div class="left-section">
							<ng-container *ngIf="activeTab === 'all-clients'; else clientList">
								<span class="show-text" i18n="@@common.show">Show</span>
								<div class="select-pages">
									<div class="nice-select tab-links-select" tabindex="0">
										<span class="current" i18n="@@clients.all_clients">All Clients
											({{clientsCount}})</span>
									</div>
								</div>
							</ng-container>
							<ng-template #clientList>
								<a (click)="activeTab='all-clients'" href="javascript:void(0)"
									class="simplified-invoice__back">
									<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
										<path
											d="M19 11H7.135l3.633-4.36a1 1 0 1 0-1.536-1.28l-5 6c-.039.047-.059.102-.088.154-.024.042-.053.078-.071.124a.985.985 0 0 0-.072.358L4 12l.001.004c0 .122.027.243.072.358.018.046.047.082.071.124.029.052.049.107.088.154l5 6a.999.999 0 1 0 1.536-1.28L7.135 13H19a1 1 0 0 0 0-2"
											fill="#030E18" fill-rule="evenodd" />
									</svg>
									<p i18n="@@clients.back_to_all_clients">Back to all clients</p>
								</a>
							</ng-template>
						</div>
						<div class="right-section">
							<a href="javascript:;" class="tu-btn-circular pink add-button clicked" (click)="activeTab='all-clients'" *ngIf="activeTab === 'edit-client'">
								<svg width="14" height="14" viewBox="0 0 14 14">
									<g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-linecap="square" stroke-width="2">
										<path d="M1 7h12M7 1v12"></path>
									</g>
								</svg>
							</a>
							<a href="javascript:;" (click)="openImportModal()" class="downloadXl"
								*ngIf="activeTab != 'edit-client'" style="padding: 14px 14px !important;">
								<svg xmlns="http://www.w3.org/2000/svg" width="26" height="25" viewBox="0 0 26 25">
									<g fill="#0CC5D1" fill-rule="evenodd">
										<path
											d="M24.375 19.458h-9.75v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438V8.108h2.438a.812.812 0 1 0 0-1.622h-2.438V4.864h9.75v14.594zM13 22.534L1.625 20.407V3.916L13 1.789v20.745zM25.188 3.243H14.624V.811a.808.808 0 0 0-.962-.796l-13 2.432A.809.809 0 0 0 0 3.243V21.08c0 .389.278.724.663.796l13 2.432a.813.813 0 0 0 .962-.796V21.08h10.563a.812.812 0 0 0 .812-.811V4.054a.812.812 0 0 0-.813-.811z" />
										<path
											d="M20.129 8.387h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M20.129 11.892h1.677a.839.839 0 0 0 0-1.678H20.13a.839.839 0 0 0 0 1.678M20.129 14.677h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M20.129 17.463h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M7.953 12.351l2.681-3.447a.838.838 0 1 0-1.323-1.032l-2.483 3.193-2.092-2.391a.838.838 0 1 0-1.263 1.104l2.306 2.636-2.338 3.007a.84.84 0 0 0 .663 1.353c.248 0 .496-.11.66-.322l2.14-2.752 2.439 2.787a.836.836 0 0 0 1.184.08.837.837 0 0 0 .079-1.183L7.953 12.35z" />
									</g>
								</svg>
								<span i18n="@@common.import_xls">Import .xls</span>
							</a>
							<a href="javascript:void(0);" class="filter-button" (click)="toggleFilter()" *ngIf="activeTab != 'edit-client'">
								<svg xmlns="http://www.w3.org/2000/svg" width="26" height="25" viewBox="0 0 26 25">
									<g fill="#0CC5D1" fill-rule="evenodd">
										<path d="M24.375 19.458h-9.75v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438V8.108h2.438a.812.812 0 1 0 0-1.622h-2.438V4.864h9.75v14.594zM13 22.534L1.625 20.407V3.916L13 1.789v20.745zM25.188 3.243H14.624V.811a.808.808 0 0 0-.962-.796l-13 2.432A.809.809 0 0 0 0 3.243V21.08c0 .389.278.724.663.796l13 2.432a.813.813 0 0 0 .962-.796V21.08h10.563a.812.812 0 0 0 .812-.811V4.054a.812.812 0 0 0-.813-.811z"/>
										<path d="M20.129 8.387h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M20.129 11.892h1.677a.839.839 0 0 0 0-1.678H20.13a.839.839 0 0 0 0 1.678M20.129 14.677h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M20.129 17.463h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M7.953 12.351l2.681-3.447a.838.838 0 1 0-1.323-1.032l-2.483 3.193-2.092-2.391a.838.838 0 1 0-1.263 1.104l2.306 2.636-2.338 3.007a.84.84 0 0 0 .663 1.353c.248 0 .496-.11.66-.322l2.14-2.752 2.439 2.787a.836.836 0 0 0 1.184.08.837.837 0 0 0 .079-1.183L7.953 12.35z"/>
									</g>
								</svg>
							</a>
						</div>
					</div>
					<div class="body-filter" [class.show]="isFilter" style="justify-content: end !important; ">
						<a href="javascript:;" (click)="openImportModal()" class="downloadXl" *ngIf="activeTab != 'edit-client'" style="padding: 14px 14px !important;">
							<svg xmlns="http://www.w3.org/2000/svg" width="26" height="25" viewBox="0 0 26 25">
								<g fill="#0CC5D1" fill-rule="evenodd">
									<path d="M24.375 19.458h-9.75v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438V8.108h2.438a.812.812 0 1 0 0-1.622h-2.438V4.864h9.75v14.594zM13 22.534L1.625 20.407V3.916L13 1.789v20.745zM25.188 3.243H14.624V.811a.808.808 0 0 0-.962-.796l-13 2.432A.809.809 0 0 0 0 3.243V21.08c0 .389.278.724.663.796l13 2.432a.813.813 0 0 0 .962-.796V21.08h10.563a.812.812 0 0 0 .812-.811V4.054a.812.812 0 0 0-.813-.811z"/>
									<path d="M20.129 8.387h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M20.129 11.892h1.677a.839.839 0 0 0 0-1.678H20.13a.839.839 0 0 0 0 1.678M20.129 14.677h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M20.129 17.463h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M7.953 12.351l2.681-3.447a.838.838 0 1 0-1.323-1.032l-2.483 3.193-2.092-2.391a.838.838 0 1 0-1.263 1.104l2.306 2.636-2.338 3.007a.84.84 0 0 0 .663 1.353c.248 0 .496-.11.66-.322l2.14-2.752 2.439 2.787a.836.836 0 0 0 1.184.08.837.837 0 0 0 .079-1.183L7.953 12.35z"/>
								</g>
							</svg>
							<span>Import .xls</span>
						</a>
					</div>
				</div> -->

				<div class="tab-content data-table__tab-content" id="pills-tabContent">
					<div *ngIf="activeTab === 'all-clients'" class="tab-pane fade show active" id="pills-all-clients"
						role="tabpanel" aria-labelledby="pills-all-clients-tab">
						<!-- <teemapp-table
							[name]="'clients'"
							[tableSchema]="clientsTable"
							[selectable]="false"
							(onLoad)="onLoadClients($event)"
							#clientsTableRef
						>
						</teemapp-table> -->
					</div>
					<!-- end #pills-all-clients -->

					<div *ngIf="activeTab === 'edit-client' || activeTab === 'view-client'">
						<edit-client [activeTab]="activeTab" [clientDetail]="activeClient" (onDelete)="onDelete($event)"
							(onSubmit)="onSubmitEditClient($event)" (orderAction)="orderAction($event)" (changeTab)="switchTab('all-clients')"></edit-client>
					</div>
					<!-- end #pills-edit-client -->
					<div *ngIf="activeTab == 'edit-invoice'">
						<edit-invoice [invoiceDetail]="activeInvoice" (onUpdate)="onSubmitEditInvoice($event)"
							(onDelete)="onDeleteInvoice($event)" [userInfo]="userInfo"
							(changeTab)="switchTab('edit-client')"></edit-invoice>
					</div>
				</div>
				<!-- end #pills-tabContent -->
			</div>
			<!-- end data-table__wrap -->
		</section>
		<!-- end data-table -->
	</div>
</ng-container>

<ng-template #noClients>
	<div class="empty_clients_page" *ngIf="!loading">
		<img src="./images/NoResults.svg" alt="" loading="lazy">
		<span i18n="@@clients.no_clients_message">You haven’t added any clients yet</span>
		<div class="primary_btn" (click)="openAddClientModal()">
			<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
				<path d="M12.5 5V19M5.5 12H19.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
			</svg>  
			<span i18n="@@clients.first_client">
				Add my first client
			</span>
		</div>
	</div>
</ng-template>

<!-- end content-container -->

